module.exports = __webpack_public_path__ + "media/images/payment_methods/eps-71ff7225c8a1a49b5630241b9db0aa3b.svg";